import React from "react";

const CARDS = [
    {
        n: "01",
        title: "Patient wallet",
        body: "Patient-held custody and purpose-bound consent.",
    },
    {
        n: "02",
        title: "Review-worthy signal",
        body: "Synthetic responsible-AI support signal. Pre-computed, not a live LLM.",
    },
    {
        n: "03",
        title: "Authorised review",
        body: "Clinician or pharmacist approves or refuses the review route.",
    },
    {
        n: "04",
        title: "Signed receipt",
        body: "KATLAS proves what was shared, withheld and decided.",
    },
];

export const ExplainerCards = () => (
    <section
        className="border-y hairline"
        data-testid="explainer-cards-section"
    >
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-12">
            <p className="mono-label mb-8">What this demo shows</p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
                {CARDS.map((c, i) => (
                    <div
                        key={c.n}
                        className={`py-6 lg:py-2 lg:px-8 ${
                            i === 0 ? "lg:pl-0" : ""
                        } ${i !== CARDS.length - 1 ? "lg:border-r hairline" : ""}`}
                        data-testid={`explainer-card-${c.n}`}
                    >
                        <span className="mono-label">{c.n}</span>
                        <h3
                            className="font-serif mt-3 mb-2"
                            style={{ fontSize: 22, letterSpacing: "-0.01em" }}
                        >
                            {c.title}
                        </h3>
                        <p style={{ color: "var(--ink-soft)", fontSize: 14 }}>
                            {c.body}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default ExplainerCards;
